export default __webpack_public_path__ + "static/media/bgtop1.95bcfed5.png";